import GraphIcon from './component'

export default GraphIcon
